import { EMPTY_QRIS_EXTCONF_FORM } from 'Main/Constant'
import { formFromQrisExtConfig } from 'Main/Utils'
import { useEffect, useState } from 'react'
import BasicInput from 'views/components/Input/BasicInput'

export function QrisExtConfigModal ({ show, isAdd, config, vendors, submitting, onClose, onSubmit }) {
  const [form, setForm] = useState(EMPTY_QRIS_EXTCONF_FORM)

  useEffect(() => {
    if (show) setForm(formFromQrisExtConfig(config))
  }, [show, config])

  if (!show) return null

  const setField = (field) => (value) => {
    setForm((f) => ({ ...f, [field]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(form)
  }

  return (
    <>
      <div className="modal-backdrop fade show" onClick={submitting ? undefined : onClose} />
      <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">{isAdd ? 'Add Qris Callback' : 'Edit Qris Callback'}</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={onClose}
                  disabled={submitting}
                />
              </div>

              <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <BasicInput label="Name" value={form.name} onChange={setField('name')} />

                <div className="mt-2">
                  <label className="form-label">Vendor Gateway</label>
                  <select
                    className="form-control"
                    value={form.payment_vendors_id}
                    onChange={(e) => setField('payment_vendors_id')(e.target.value)}
                  >
                    <option value="">-- Select Vendor Gateway --</option>
                    {vendors.map((pv) => (
                      <option key={pv.id} value={pv.id}>{pv.name}</option>
                    ))}
                  </select>
                </div>

                <div className="mt-2">
                  <BasicInput label="Prefix" value={form.prefix} onChange={setField('prefix')} />
                </div>

                <div className="mt-2">
                  <BasicInput label="Callback Url" value={form.callback_url} onChange={setField('callback_url')} />
                </div>

                <div className="mt-2">
                  <BasicInput label="Description" type="textarea" value={form.description} onChange={setField('description')} />
                </div>

                <div className="form-check mt-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="qc_enabled"
                    checked={form.enabled}
                    onChange={(e) => setField('enabled')(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="qc_enabled">Enabled</label>
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-light text-black" onClick={onClose} disabled={submitting}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-success" disabled={submitting}>
                  <i className={`fa-solid ${submitting ? 'fa-circle-o-notch fa-spin' : 'fa-floppy-disk'}`} />{' '}
                  {submitting ? 'Saving...' : (isAdd ? 'Add Qris Callback' : 'Save Changes')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
